module.exports = __webpack_public_path__ + "img/elisa2.4f889e48.png";